import CloudImg from "public/openStack/cloud.png";
import GraphImg from "public/openStack/graph.png";
import RocketImg from "public/openStack/rocket.png";
import SecImg from "public/openStack/tdesign_secured-filled.png";

export const WHY_CHOOSE_CONSTANTS = {
  title: "Why Choose OneMind’s Managed OpenStack?",
  desc: "Enterprise-grade cloud infrastructure, fully managed and secure for your business needs",
  list: [
    {
      image: SecImg,
      title: "Fully Managed & Secure",
      content:
        "We manage deployment, upgrades, scaling, and optimization—end to end. Built-in security like encryption, identity integration, and role-based access ensures protection and compliance.",
    },
    {
      image: RocketImg,
      title: "Fast Provisioning, Full Control",
      content:
        "Spin up virtual machines, networks, and storage in minutes. Developers get speed and flexibility through UI and APIs, while governance features ensure consistency and control.",
    },
    {
      image: CloudImg,
      title: "Private Cloud Simplicity ",
      content:
        "Enjoy the performance and control of private infrastructure with the ease of public cloud. No vendor lock-in. Full data sovereignty. Hybrid and edge-ready by design.",
    },
    {
      image: GraphImg,
      title: "Unified Visibility & Observability",
      content:
        "Monitor and manage your entire infrastructure in real-time. Track usage, get alerts, and maintain visibility across compute, storage, and networking layers—all from a single dashboard.",
    },
  ],
};
